export default "__VITE_ASSET__62597b9d__"